//=============================================================================
// Contents   : HRDB
//              従業員詳細
//              GetEmployee
// Author     : RV光永 
// LastUpdate : 2023/01/05
// Since      : 2022/12/2
//=============================================================================

/* ======================================================================================================================================================= */  
/* ==================================================================== Start Of Program ================================================================= */  
/* ======================================================================================================================================================= */ 


/* ======================================================================== */  
/* ============================ import ==================================== */  
/* ======================================================================== */  
/* ====== React ====== */
import React, { useEffect, useState } from "react";
import { useForm} from "react-hook-form";
import { useNavigate,useLocation } from 'react-router-dom';
import { useProvideData } from "03CommonApiParts/use-context";

/* ====== CSS ====== */
/* ====== Image ====== */
/* ====== Component Js/Jsx ====== */
import { Underbar } from "02CommonUiParts/OtherParts/Underbar";
import { LeftTitleTable } from "02CommonUiParts/TableParts/LeftTitleTable";
import { SnackBar } from "02CommonUiParts/MessageParts/SnackBar";
import { LoadingProgressBar } from "02CommonUiParts/OtherParts/LoadingProgressBar";
import { Title } from "01Pages/Common/UiParts/Title";
import { assets } from "03CommonApiParts/Configuration";
import { CFArrayFount, CFDateFormatEdit, CFStringDecodeJP, CFStringEncodeJP } from "03CommonApiParts/CommonFunction";
/* ====== Style ====== */
import { StyleCommon } from "01Pages/Common/Style/StyleCommon";
import { StyleEmployee } from "01Pages/Employee/Information/StyleEmployee";
import { HistryTable } from "02CommonUiParts/TableParts/HistoryTable";
import { Table } from "02CommonUiParts/TableParts/Table";
import { CODEDIFINITION_STORAGE, screenMaster, USERINFO_STORAGE } from "03CommonApiParts/CodeDefinition";


/* ======================================================================== */  
/* ============================ Styles ==================================== */  
/* ======================================================================== */ 

/* ======================================================================== */  
/* ================== global variables/functions ========================== */  
/* ======================================================================== */  
/* ベース64スイッチ */
const base64Swicth = true;	//エンコード処理スイッチ
/* スタイル */
const CommonStyle =  StyleCommon();//共通スタイルドコンポーネント
const EmployeeStyle =  StyleEmployee();//従業員スタイルドコンポーネント

/* ======================================================================== */  
/* ============================ Main ====================================== */  
/* ======================================================================== */ 

/* ========= 従業員詳細 ========= */
export const GetHistoryEmployee = () => {
    /* ---------------------------------------------------- */
    /* ------------------ Instance ------------------------ */
    /* ---------------------------------------------------- */

    const navigate = useNavigate();//画面遷移用
    const apiData = useProvideData();//APIデータ取得
    const location = useLocation();//遷移元データ取得用
    const empNmb =  location.state.empNmb ;//従業員一覧からのID
    /* ----------------------------------------------------- */
    /* ----------------- reack-hook-form ------------------- */
    /* ----------------------------------------------------- */

    /* ====== hookformを定義 ====== */
    const { register, reset, setValue,formState: { errors } } = useForm({//setValue, onChange
		mode: 'onBlur',
		reValidateMode: 'onChange',
		shouldUseNativeValidation: false,
		shouldUnregister: false,
        // defaultValues: {
        //     payload:[
        //     ]
        // },
	});


    /* ---------------------------------------------------- */
    /* ------------------ variables ----------------------- */
    /* ---------------------------------------------------- */
    /* ====== sessionStorageからの情報を定義 ====== */ 
    const codeDefinitionStorage = sessionStorage.getItem(CODEDIFINITION_STORAGE);//sessionStorageからコードマスタを取得
	var codeDefinitionValue = JSON.parse(codeDefinitionStorage);//JSON 文字列を取得し、JavaScriptオブジェクトに変換
    /* ====== localStorageからの情報を定義 ====== */ 
    /* ====== storageから取得した情報をJavaScriptオブジェクトに変換 ====== */ 
    /* USERINFO_STORAGEから従業員情報を取得 */
    const userInfoStorage = sessionStorage.getItem(USERINFO_STORAGE)
    var userInfoValue = JSON.parse(userInfoStorage);//JSON 文字列を取得し、JavaScriptオブジェクトに変換
    const userName = userInfoValue.empJpnSrname + ' ' + userInfoValue.empJpnName;//名前
    const screenId = CFArrayFount(screenMaster,'path',location.pathname).id;//画面Id
    // var passValue = JSON.parse(storageToken);//JSON 文字列を取得し、JavaScriptオブジェクトに変換
    const keyList = {
        //基本情報
        base:'aplySrtDate',
        //所属部署情報
        dpt:'afiDptAplySrtDate',
        //エキスパート情報
        expert:'exptAplySrtDate',
        //派遣社員情報
        temporary:'tmpCntrTermSrtDate',
        //契約社員情報
        contract:'cntrTermSrtDate',
        //出向(受)社員情報
        accepted:'secAcpCntrTermSrtDate',
        //出向(出)社員情報
        assigned:'crntSecTermSrtDate',
        //休務/休職情報
        absence:'absenceTermSrtDate',
        //転入情報
        movein:'moveInDate',				
        //転出情報
        moveout:'moveOutDate'
    };

    /* ---------------------------------------------------- */
    /* ---------------------- state ----------------------- */
    /* ---------------------------------------------------- */
    const [progress, setProgress] = useState(false); //プログレスバー表示用
    const [snackbarMessage, setSnackbarMessage] = useState({ //スナックバー表示用
        open:false,
    });
    const [loading, setLoading] = useState(true); //
    const [historyData, setHistoryData] = useState([]); //履歴用
    const [displayData, setDisplayData] = useState(); //画面表示用
    const [changeFlags, setChangeFlags] = useState(); //変更点保存用
    /* ---------------------------------------------------- */
    /* -------------------- Master ------------------------ */
    /* ---------------------------------------------------- */
	const employmentTermDisitionFlag = CFArrayFount(codeDefinitionValue,'code','employmentTermDisitionFlag');//雇用期間の定めフラグ
	const introductionScheduleTemporaryFlag = CFArrayFount(codeDefinitionValue,'code','introductionScheduleTemporaryFlag');//紹介予定派遣フラグ
	const flexApplyFlag = CFArrayFount(codeDefinitionValue,'code','flexApplyFlag');//フレックス適用フラグ

    /* ---------------------------------------------------- */
    /* ----------------- 　取得API項目　 -------------------- */
    /* ---------------------------------------------------- */
	const apiItem = {
		/* 基本情報の項目 */
		base:[
			{name:'otpDate',             		base64:false,type:'date'},  //出力日
			{name:'aplySrtDate',            	base64:false, type:'date' },  //適用日
			{name:'empNmb',                 	base64:false },  //従業員番号						
			{name:'empJpnSrname',	        	base64:true },  //従業員日本語姓						
			{name:'empJpnName',	            	base64:true },  //従業員日本語名						
			{name:'empJpnMidName',          	base64:true },  //従業員日本語ミドルネーム						
			{name:'empFrgnSrname',          	base64:true },  //従業員フリガナ姓						
			{name:'empFrgnName',	        	base64:true },  //従業員フリガナ名
			{name:'empFrgnMidName',         	base64:true },  //従業員フリガナミドルネーム						
			{name:'empEngSrname',	        	base64:false },  //従業員英語姓						
			{name:'empEngName',	            	base64:false },  //従業員英語名						
			{name:'empEngMidName',          	base64:false },  //従業員英語ミドルネーム						
			{name:'empAbrName',	            	base64:true },  //従業員略名						
			{name:'empFmlyName',            	base64:true },  //従業員戸籍名						
			{name:'gendName',			        base64:true },  //性別名					
			{name:'bday',				    	base64:false,type:'date' },  //生年月日						
			{name:'empiSttsName',			    base64:true },  //雇用形態コード						
			{name:'entryDate',					base64:false, type:'date' },  //入社日						
			{name:'plgePresnDate',				base64:false, type:'date'},  //誓約書提出日						
			{name:'workLocoName',				base64:true },  //勤務地名					
			{name:'workLocoAdres',				base64:true },	//勤務地住所						
			{name:'rkName',				    	base64:true },  //ランク名
			{name:'hrAprvNmb',					base64:false },  //人事稟議番号						
			{name:'aprvOrgTimeCst',				base64:false },	//稟議起案時費用						
			{name:'lastToWorkDate',				base64:false, type:'date' }, //最終出社日						
			{name:'rtiDate',					base64:false, type:'date'},  //退職日						
			{name:'cmntField',					base64:true }   //コメント欄											
		],
		/* 所属部署情報の項目 */
		dpt:[
			{name:'afiDptAplySrtDate',         	base64:false, type:'date' },  //適用日					
			{name:'dptCd',	name2:'dptName',    base64:false, base642:true},  //部署コード 部署名	
            {name:'lboCstClasfName',			base64:true },	//人件費区分名	
			{name:'postName',			        base64:true },  //役職名
			{name:'cncDptList',					base64:false,type:'list' },	//兼務部署リスト										
		],        
		/* エキスパートの項目 */
		expert:[
			{name:'exptAplySrtDate',   	base64:false,type:'date'},//適用開始日
			{name:'gradeName',          base64:true},//等級名					
			{name:'mnaSpvrFlag',	 	base64:false}//管理監督者フラグ
		],
		/* 派遣の項目 */
		temporary:[
			{name:'tmpAgnCmpCd', name2:'tmpAgnCmpName',	base64:false, base642:true},//派遣元会社コード 派遣元会社名
			{name:'empiTermDciFlag',	                base64:false},//雇用期間の定めフラグ
			{name:'itrSchedTmpFlag',	                base64:false},//紹介予定派遣フラグ
			{name:'tmpCntrTermSrtDate',	                base64:false,type:'date'},//契約開始日
			{name:'tmpBfCntrTermEndDate',	            base64:false,type:'date'},//契約満了予定日
			{name:'idiCntDate',	                    	base64:false,type:'date'},//個人抵触日
			{name:'tmpFirstRspPsnEmpNmb', 	name2:'tmpFirstRspEmpFullName',		base64:false, base642:true},//派遣先責任者従業員番号	派遣先責任者氏名
			{name:'ledrEmpNmb',             name2:'ledrFullName',	            base64:false, base642:true},//指揮命令者従業員番号	指揮命令者氏名
			{name:'hurRate',	                        base64:false},//時間単価
			{name:'frsFirstHurRate',	                base64:false},//初回時間単価
			{name:'uitCstRema',	                    	base64:true},//単価備考
			{name:'flexAplyFlag',	                    base64:false},//フレックス適用フラグ
			{name:'tmpBsiContField',	                base64:true},//業務内容欄
			{name:'tmpBsiContDta',	                   	base64:true},//業務内容詳細										
			{name:'tmpInfoRema',	               		base64:true},//派遣社員情報備考
			{name:'cntrNtTgtFlag',	               		base64:false},//契約書対象外フラグ
			{name:'webAttdNtTgtFlag',	                base64:false},//WEB勤怠対象外フラグ
		],
		/* 契約社員の項目 */		
		contract:[
			{name:'slaFormName',	            		base64:true},//給与形態名
			{name:'ocuName',	                		base64:true},//職種名
			{name:'distMerh',	        			    base64:true},//配布方法
			{name:'cntrBsiContField',	        	    base64:true},//業務内容欄
			{name:'mergePrintSprt',	        			base64:true},//差し込み印刷対応
			{name:'cntrSrtDate',	        			base64:false,type:'date'},//契約開始日
			{name:'lngEmpiTerm',	        			base64:false,type:'date'},//最長雇用期間
			{name:'upIte',	                			base64:false},//更新間隔	
			{name:'cntrTermSrtDate',	    			base64:false,type:'date'},//契約期間開始日
			{name:'cntrTermExpiDate',				    base64:false,type:'date'},//契約期間満了予定日
			{name:'cntrInfoRema',	    			    base64:true},//契約社員情報備考
			{name:'gradeName',	            			base64:true},//等級名
			{name:'mnaSpvrFlag',	        			base64:false},//管理監督者フラグ
		],
		/* 出向(受)の項目 */		
		accepted:[
			{name:'secFrmCmpCd',name2:'secFrmCmpName',  base64:false, base642:true},//出向元会社コード,出向元会社名
			{name:'slaBaseName',	            		base64:true},//給与基準名
			{name:'bsiTripExpeStndName',	    		base64:true},//旅費基準名
			{name:'cntrFrmtName',	            		base64:true},//契約書フォーマット名
			{name:'secAcpFirstCntrSrtDate',	        	base64:false,type:'date'},//初回契約開始日
			{name:'secAcpCntrTermSrtDate',	    		base64:false,type:'date'},//現契約期間開始日
			{name:'secAcpCntrTermExpiDate',				base64:false,type:'date'},//現契約満了予定日
			{name:'secAcpInfoRema',	    			    base64:true},//出向(受)社員情報備考								
			{name:'mnaSpvrFlag',	        			base64:false},//管理監督者フラグ
		],
		/* 出向(出)の項目 */
		assigned:[
			{name:'secSrtDate',	           				base64:false,type:'date'},//出向開始日										
			{name:'rtnDate',	           				base64:false,type:'date'},//帰任日										
			{name:'secDestnCmpCd',name2:'secDestnCmpName',base64:false,base642:true},//出向先会社コード 出向先会社名					
			{name:'dptName',	           				base64:true},//部署名
			{name:'secDestnDpt',	       				base64:true},//出向先部署名										
			{name:'cstBrd',	               				base64:false},//費用負担
			{name:'bfSecAfiDptCd',	name2:'bfSecAfiDptName', base64:false,base642:true},//出向前所属部署コード 出向前所属部署名 	
			{name:'secAsiInfoRema',	   				    base64:true},//出向(出)社員情報備考										
			{name:'crntSecTermSrtDate',	   				base64:false,type:'date'},//現出向期間開始日										
			{name:'crntSecTermEndDate',	   				base64:false,type:'date'},//現出向期間終了日															
		],
		absence:[
			{name:'absenceTermSrtDate',					base64:false,type:'date'},//休職期間開始日
			{name:'absenceTermEndDate',					base64:false,type:'date'},//休職期間終了日
			{name:'loaClasfName',						base64:true},//休務/休職区分名
			{name:'lastUdr',							base64:true},//最終更新者
			{name:'lastUpDate',							base64:false}//最終更新日時
		],
		movein:[
			{name:'moveInDate',							base64:false, type:'date'},//転入日
			{name:'moveInRemaField',					base64:true},//転入備考欄
			{name:'lastUdr',							base64:true},//最終更新者
			{name:'lastUpDate',							base64:false}//最終更新日時
		],
		moveout:[
			{name:'moveOutDate',						base64:false, type:'date'},//転出日
			{name:'moveOutRemaField',					base64:true},//転出備考欄
			{name:'lastUdr',							base64:true},//最終更新者
			{name:'lastUpDate',							base64:false}//最終更新日時
		],
		cncDptList:[
			{name: 'cncDptCd',	name2:'cncDptName', 	base64:false, base642:true},//兼務部署コード 兼務部署名
			{name: 'cncPostName',						base64:true},//兼務役職コード
		]
	};
    /* ---------------------------------------------------- */
    /* ---------------------- function -------------------- */
    /* ---------------------------------------------------- */

    /* ====== 初期表示 ====== */ 
    useEffect(() => {
        /* 詳細情報の取得 */
        getDetail();
        setLoading(true)
        // eslint-disable-next-line 
    },[]);

    /* ====== APIから従業員データ取得 ====== */ 
    const getDetail = async(value) => {
        /* プログレスバー表示 */
        setProgress(true);

        reset();
        /* リクエスト*/
        const handlingInformation = {};
        let key = {};
        /* 操作情報 */
        handlingInformation.hndEmpMailAdrs = userInfoValue.mail;
        handlingInformation.hndEmpFullName = CFStringEncodeJP(userName,base64Swicth);
        handlingInformation.sreId = screenId;
        handlingInformation.hndId = 'GET';
        /* 検索キー */
        key.empNmb  = empNmb;
        key.histTrgCd = value?.histTrgCd ? value.histTrgCd : null;
        key.upDate    =  value?.upDate ? value.upDate : null;
        const apiBody = { handlingInformation: handlingInformation , key : key};

        /* リクエスト先 */
        const apiPath = '/employee/getdetailemployeehistory';	//API Path
        // /* API処理開始 */
        await apiData.getDataPost(apiPath, apiBody, (result) => {
            /* プログレスバー非表示 */
            setProgress(false);
           
            /* APIリクエスト結果を判定 */
            if (result.isSuccessed) {//APIリクエスト結果 = 正常
                const data = result.responseData.data.payload;
                const historyInfo = [];
                data.historyInfo.forEach((hisRow,index)=>{
                    historyInfo.push({
                        aplySrtDate:hisRow.aplySrtDate,
                        upDate:hisRow.upDate,
                        udrFullName:hisRow.udrFullName ? CFStringDecodeJP(hisRow.udrFullName,base64Swicth) : hisRow.udrFullName,
                        histTrgCd:hisRow.histTrgCd,
                        aplyFlag:hisRow.aplyFlag,
                        id:index
                    });
                });
                setHistoryData(historyInfo);
                /*  変更フラグ */
                let changeFlagsObject = {};

                /* objectデータの編集(基本情報・契約系) */
                const objectDataEdit = (id,infoName,detailName,bfDetailName,change) =>{
                    let result = {};
                    apiItem[id].forEach((item)=>{
                        if(item.type === 'list'){
                            result[item.name] = [];
                            const oldData = [];
                            const newData = [];
                           
                            if(change){
                                data[infoName][bfDetailName][item.name].forEach((listData,listIndex)=>{
                                    const oldDataObject = {};
                                    apiItem[item.name].forEach((listItem)=>{
                                        /* name2がある場合 */
                                        if(listItem.name2){
                                            let value1;
                                            let value2;
                                            if(listItem.base64){
                                                value1 = listData[listItem.name] ? CFStringDecodeJP(listData[listItem.name],base64Swicth) : ''
                                            }else{
                                                value1 = listData[listItem.name];
                                            }
                                            if(listItem.base642){
                                                value2 = listData[listItem.name2]? CFStringDecodeJP(listData[listItem.name2],base64Swicth) : ''
                                            }else{
                                                value2 = listData[listItem.name2];
                                            };
                                            oldDataObject[listItem.name] = value2 ? value1 + ' ' + value2 : value1;
                                        }else{
                                            if(listItem.base64){
                                                oldDataObject[listItem.name] = listData[listItem.name] ? CFStringDecodeJP(listData[listItem.name],base64Swicth) : '';
                                            }else{
                                                oldDataObject[listItem.name] = listData[listItem.name];
                                            }
                                        }
                                    });
                                    oldData.push(oldDataObject);
                                });
                                data[infoName]?.[detailName]?.[item.name]?.forEach((listData,listIndex)=>{
                                    const newDataObject = {};
                                    apiItem[item.name].forEach((listItem)=>{
                                        /* name2がある場合 */
                                        if(listItem.name2){
                                            let value1;
                                            let value2;
                                            if(listItem.base64){
                                                value1 = listData[listItem.name] ? CFStringDecodeJP(listData[listItem.name],base64Swicth) : ''
                                            }else{
                                                value1 = listData[listItem.name];
                                            }
                                            if(listItem.base642){
                                                value2 = listData[listItem.name2]? CFStringDecodeJP(listData[listItem.name2],base64Swicth) : ''
                                            }else{
                                                value2 = listData[listItem.name2];
                                            };
                                            newDataObject[listItem.name] = value2 ? value1 + ' ' + value2 : value1;
                                        }else{
                                            if(listItem.base64){
                                                newDataObject[listItem.name] = listData[listItem.name] ? CFStringDecodeJP(listData[listItem.name],base64Swicth) : '';
                                            }else{
                                                newDataObject[listItem.name] = listData[listItem.name];
                                            }
                                        }
                                    });
                                    newData.push(newDataObject);
                                });
                                result[item.name] = arrayChangeDataEdit(item.name,oldData,newData,'cncDptCd');
                            }else{
                                data[infoName][detailName][item.name].forEach((listData,listIndex)=>{
                                    const oldDataObject = {};
                                    apiItem[item.name].forEach((listItem)=>{
                                        /* name2がある場合 */
                                        if(listItem.name2){
                                            let value1;
                                            let value2;
                                            if(listItem.base64){
                                                value1 = listData[listItem.name] ? CFStringDecodeJP(listData[listItem.name],base64Swicth) : ''
                                            }else{
                                                value1 = listData[listItem.name];
                                            }
                                            if(listItem.base642){
                                                value2 = listData[listItem.name2]? CFStringDecodeJP(listData[listItem.name2],base64Swicth) : ''
                                            }else{
                                                value2 = listData[listItem.name2];
                                            };
                                            oldDataObject[listItem.name] = value2 ? value1 + ' ' + value2 : value1;
                                        }else{
                                            if(listItem.base64){
                                                oldDataObject[listItem.name] = listData[listItem.name] ? CFStringDecodeJP(listData[listItem.name],base64Swicth) : '';
                                            }else{
                                                oldDataObject[listItem.name] = listData[listItem.name];
                                            }
                                        }
                                    });
                                    oldData.push(oldDataObject);
                                });
                                result[item.name] = oldData;
                            }
                            

                            
                        }else{
                            if(change){
                                /* name2がある場合 */
                                if(item.name2){
                                    let value1;
                                    let value2;
                                    let value1New;
                                    let value2New;
                                    /* データの振り分け */
                                    if(item.base64){
                                        /* デコードが必要な項目 */
                                        value1New  = data[infoName][detailName][item.name] ?  CFStringDecodeJP(data[infoName][detailName][item.name],base64Swicth) : '';
                                        value1 = data[infoName][bfDetailName][item.name] ? CFStringDecodeJP(data[infoName][bfDetailName][item.name],base64Swicth) : ''
                                    }else{
                                        /* デコードが不要な項目 */
                                        value1New = data[infoName][detailName][item.name];
                                        value1 = data[infoName][bfDetailName][item.name];
                                    }
                                    /* データの振り分け */
                                    if(item.base642){
                                        /* デコードが必要な項目 */
                                        value2New  = data[infoName][detailName][item.name2] ?  CFStringDecodeJP(data[infoName][detailName][item.name2],base64Swicth) : '';
                                        value2 = data[infoName][bfDetailName][item.name2] ? CFStringDecodeJP(data[infoName][bfDetailName][item.name2],base64Swicth) : ''
                                    }else{
                                         /* デコードが不要な項目 */
                                        value2New = data[infoName][detailName][item.name2];
                                        value2 = data[infoName][bfDetailName][item.name2];
                                    };
                                    /* データの格納 */
                                    if(value1 === value1New){
                                        /* newとoldが一致 */
                                        changeFlagsObject[item.name] = false;
                                        result[item.name] =  value2New ? value1New + ' ' + value2New: value1New;
                                    }else{
                                        /* newとoldが一致しない */
                                        changeFlagsObject[item.name] = true;
                                        /* value1が存在する場合 */
                                        if(value1){
                                            result[item.name] = value2 ? value1 + ' ' + value2 : value1;
                                        }
                                        /* value1が存在しない場合 */
                                        else{
                                            result[item.name] = '未入力';
                                        }
                                        /* value1Newが存在する場合 */
                                        if(value1New){
                                            result[`${item.name}New`] =  value2New ? value1New + ' ' + value2New: value1New;
                                        }
                                         /* newValueが存在しない場合 */
                                        else{
                                            /* 適用開始日存在する場合は(追加もしくは変更) */
                                            if(data[infoName][detailName][keyList[id]]){
                                                /* 未入力と表示 */
                                                result[`${item.name}New`] = '未入力';
                                            }
                                                /* 適用開始日存在しない場合 */
                                            else{
                                                /* item.nameが適用開始日の場合 */
                                                if(item.name === keyList[id]){
                                                    /* 変更後の値に削除(赤文字)と表示 */
                                                    changeFlagsObject[item.name] = true;
                                                    result[`${item.name}New`] = '削除';
                                                }
                                                /* 適用開始日以外の場合　*/
                                                else{
                                                    /* 変更後の値を表示しない */
                                                    changeFlagsObject[item.name] = false;
                                                }
                                                
                                            }
                                        };
                                    };
                                    
                                }else{
                                    var oldValue;
                                    var newValue;
                                    /* データの振り分け */
                                    if(item.base64){
                                        /* デコードが必要な項目 */
                                        oldValue = data[infoName][bfDetailName][item.name] ? CFStringDecodeJP(data[infoName][bfDetailName][item.name],base64Swicth) : '';
                                        newValue = data[infoName][detailName][item.name] ?  CFStringDecodeJP(data[infoName][detailName][item.name],base64Swicth) : '';
                                    }else{
                                        /* デコードが不要な項目 */
                                        oldValue = data[infoName][bfDetailName][item.name];
                                        newValue = data[infoName][detailName][item.name];
                                    };
                                    /* データの格納 */
                                    if(oldValue === newValue){
                                        /* newとoldが一致 */
                                        changeFlagsObject[item.name] = false;
                                        result[item.name] = newValue;
                                    }else{
                                         /* newとoldが一致しない */
                                        changeFlagsObject[item.name] = true;
                                        /* oldValueが存在する場合 */
                                        if(oldValue){
                                            result[item.name] = oldValue;
                                        }
                                        /* oldValueが存在しない場合 */
                                        else{
                                            result[item.name] = '未入力';
                                        };
                                        /* newValueが存在する場合 */
                                        if(newValue !== undefined){
                                            result[`${item.name}New`] = newValue;
                                        }
                                        /* newValueが存在しない場合 */
                                        else{
                                            /* 適用開始日存在する場合は(追加もしくは変更) */
                                            if(data[infoName][detailName][keyList[id]]){
                                                /* 未入力と表示 */
                                                result[`${item.name}New`] = '未入力';
                                            }
                                             /* 適用開始日存在しない場合 */
                                            else{
                                                /* item.nameが適用開始日の場合 */
                                                if(item.name === keyList[id]){
                                                    /* 変更後の値に削除(赤文字)と表示 */
                                                    changeFlagsObject[item.name] = true;
                                                    result[`${item.name}New`] = '削除';
                                                }
                                                /* 適用開始日以外の場合　*/
                                                else{
                                                    /* 変更後の値を表示しない */
                                                    changeFlagsObject[item.name] = false;
                                                }
                                                
                                            }
                                        };
                                    };
                                }
                            }else{
                                /* name2がある場合 */
                                if(item.name2){
                                    let value1;
                                    let value2;
                                    if(item.base64){
                                        value1 = data[infoName][detailName][item.name] ? CFStringDecodeJP(data[infoName][detailName][item.name],base64Swicth) : '';
                                    }else{
                                        value1 = data[infoName][detailName][item.name];
                                    };
                                   
                                    if(item.base642){
                                        value2 = data[infoName][detailName][item.name2] ? CFStringDecodeJP(data[infoName][detailName][item.name2],base64Swicth) : '';
                                    }else{
                                       
                                        value2 = data[infoName][detailName][item.name2];
                                    };
                                    result[item.name] = value2 ? value1 + ' ' + value2 : value1;
                                }else{
                                    if(item.base64){
                                        result[item.name] = data[infoName][detailName][item.name] ? CFStringDecodeJP(data[infoName][detailName][item.name],base64Swicth) : '';
                                    }else{
                                        result[item.name] = data[infoName][detailName][item.name];
                                    }
                                }
                            };
                        };
                    });
                    return result;
                };
                /* Arrayデータの編集(転入/転出/休務休暇系) */
                const arrayDataEdit = (id,infoName,listName) =>{
                    let result = [];
                    data[infoName][listName].forEach((row)=>{
                        const object = {};
                        apiItem[id].forEach((item)=>{
                            if(item.base64){
                                object[item.name] = CFStringDecodeJP(row[item.name],base64Swicth);
                            }else if(item.type === 'date'){
                                object[item.name] = CFDateFormatEdit(row[item.name]);
                            }else{
                                object[item.name] = row[item.name] ? row[item.name] : '';
                            }
                        });
                        result.push(object);
                    });
                    return result;
                };
                /* 変更ありArrayデータの編集(転入/転出/休務休暇系) */
                const arrayChangeDataEdit = (id,oldData,newData,keyName) =>{
                    const storageData = [];
                    changeFlagsObject[id] = [];
                    const keys = [];
                    apiItem[id].forEach((item)=>{
                        keys.push(item.name);
                    });
                    const dataEdit = (data1,data2,type) =>{
                        data1.forEach((row)=>{
                            const dataObject = {};
                            const chengeObject = {};
                            const dataCheck = CFArrayFount(data2,keyName,row[keyName]);
                            /* 更新データ */
                            if(dataCheck){
                                keys.forEach((key)=>{
                                    /* 変更点なし */
                                    if(row[key] === dataCheck[key]){
                                        dataObject[key] = row[key] ? row[key] : '未入力';
                                        chengeObject[key] = false;
                                    }
                                    /* 変更点あり */
                                    else{
                                        if(type === 'after'){
                                            dataObject[key] = dataCheck[key] ? dataCheck[key] : '未入力';
                                            dataObject[`${key}New`] = row[key] ? row[key] : '未入力';
                                            chengeObject[key] = true;
                                        }else{
                                            dataObject[key] = row[key] ? row[key] : '未入力';
                                            dataObject[`${key}New`] = dataCheck[key] ? dataCheck[key] : '未入力';;
                                            chengeObject[key] = true;
                                        }
                                    }
                                })
                                 /* 新規登録データ */
                                 storageData.push(dataObject);
                            }
                            else{
                                if(type === 'after'){
                                    keys.forEach((key)=>{
                                        /* 変更ありとしてデータセット */
                                        chengeObject[key] = true;
                                        /* newでセット */
                                        dataObject[`${key}New`] = row[key] ? row[key] : '未入力';
                                    });
                                    /* 新規登録データ */
                                    storageData.push({
                                        ...row,
                                        ...dataObject,
                                        dataType:'register'
                                    });
                                }else{
                                    /* 削除データ */
                                    storageData.push({
                                        ...row,
                                        dataType:'delete'
                                    });
                                }
                               
                            };
                            changeFlagsObject[id].push(chengeObject);
                        })
                        
                        /* data2のみにしか存在しないデータがないかチェック */
                        data2.forEach((row2)=>{
                            const dataObject = {};
                            const chengeObject = {};
                            const dataCheck = CFArrayFount(data1,keyName,row2[keyName]);
                            if(!dataCheck){
                                if(type === 'after'){
                                    /* 削除データ */
                                    storageData.push({
                                        ...row2,
                                        dataType:'delete'
                                    });
                                }else{
                                    keys.forEach((key)=>{
                                        /* 変更ありとしてデータセット */
                                        chengeObject[key] = true;
                                        /* newでセット */
                                        dataObject[`${key}New`] = row2[key] ? row2[key] : '未入力';
                                    });
                                   /* 新規登録データ */
                                    storageData.push({
                                        ...row2,
                                        ...dataObject,
                                        dataType:'register'
                                    });
                                }
                                changeFlagsObject[id].push(chengeObject);
                            }
                        })
                    }
                    if(oldData.length > newData.length){
                        /* oldDataの方が大きい場合はbefore */
                        dataEdit(oldData,newData,'before');
                    }else{
                        /* oldDataの方が小さい場合はafter*/
                        dataEdit(newData,oldData,'after');
                    };
                    return storageData;
                }
                /* ---------------------------------------- */
                /* ---------------- 表示データ -------------- */
                /* ---------------------------------------- */
                const nowAply = historyInfo[0];
                let editData = {};
                switch(value?.histTrgCd ? value?.histTrgCd : nowAply.histTrgCd){
                    /* 基本情報~契約の履歴の場合は、休務休職〜転出も表示 */
                    case 'basicInformation'://基本情報
                        editData.base = objectDataEdit('base','baseInfo','baseDetail','baseBfDetail',true);
                        editData.dpt = objectDataEdit('dpt','dptInfo','dptDetail','dptBfDetail');                                                 
                        if(data.exptInfo !== undefined){
                            editData.expert = objectDataEdit('expert','exptInfo','exptDetail','exptBfDetail');
                        };
                        if(data.tmpInfo !== undefined){
                            editData.temporary = objectDataEdit('temporary','tmpInfo','tmpDetail','tmpBfDetail');
                        };
                        if(data.contInfo !== undefined){
                            editData.contract = objectDataEdit('contract','contInfo','contDetail','contBfDetail');
                        };
                        if(data.acpInfo !== undefined){
                            editData.accepted = objectDataEdit('accepted','acpInfo','acpDetail','acpBfDetail');
                        };
                        if(data.asgInfo !== undefined){
                            editData.assigned = objectDataEdit('assigned','asgInfo','asgDetail','asgBfDetail');
                        };
                        editData.absence = arrayDataEdit('absence','levInfo','levList');
                        editData.movein = arrayDataEdit('movein','moveInInfo','moveInList');
                        editData.moveout = arrayDataEdit('moveout','moveOutInfo','moveOutList');
                    break;
                    /* 所属部署情報~契約の履歴の場合は、休務休職〜転出も表示 */
                    case 'affiliatedDepartmentInformation'://所属部署情報
                    editData.base = objectDataEdit('base','baseInfo','baseDetail','baseBfDetail');                   
                    editData.dpt = objectDataEdit('dpt','dptInfo','dptDetail','dptBfDetail',true);           
                        if(data.exptInfo !== undefined){
                            editData.expert = objectDataEdit('expert','exptInfo','exptDetail','exptBfDetail');
                        };
                        if(data.tmpInfo !== undefined){
                            editData.temporary = objectDataEdit('temporary','tmpInfo','tmpDetail','tmpBfDetail');
                        };
                        if(data.contInfo !== undefined){
                            editData.contract = objectDataEdit('contract','contInfo','contDetail','contBfDetail');
                        };
                        if(data.acpInfo !== undefined){
                            editData.accepted = objectDataEdit('accepted','acpInfo','acpDetail','acpBfDetail');
                        };   
                        if(data.asgInfo !== undefined){
                            editData.assigned = objectDataEdit('assigned','asgInfo','asgDetail','asgBfDetail');
                        };
                        editData.absence = arrayDataEdit('absence','levInfo','levList');
                        editData.movein = arrayDataEdit('movein','moveInInfo','moveInList');
                        editData.moveout = arrayDataEdit('moveout','moveOutInfo','moveOutList');
                    break;                    
                    case 'expertEmployeeInformation'://エキスパート社員情報
                        editData.base = objectDataEdit('base','baseInfo','baseDetail','baseBfDetail');
                        editData.dpt = objectDataEdit('dpt','dptInfo','dptDetail','dptBfDetail');
                        editData.expert = objectDataEdit('expert','exptInfo','exptDetail','exptBfDetail',true);
                        if(data.asgInfo !== undefined){
                            editData.assigned = objectDataEdit('assigned','asgInfo','asgDetail','asgBfDetail');
                        };
                        editData.absence = arrayDataEdit('absence','levInfo','levList');
                        editData.movein = arrayDataEdit('movein','moveInInfo','moveInList');
                        editData.moveout = arrayDataEdit('moveout','moveOutInfo','moveOutList');
                    break;
                    case 'temporaryEmployeeInformation'://派遣社員情報
                        editData.base = objectDataEdit('base','baseInfo','baseDetail','baseBfDetail');
                        editData.dpt = objectDataEdit('dpt','dptInfo','dptDetail','dptBfDetail');  
                        editData.temporary = objectDataEdit('temporary','tmpInfo','tmpDetail','tmpBfDetail',true);
                        if(data.asgInfo !== undefined){
                            editData.assigned = objectDataEdit('assigned','asgInfo','asgDetail','asgBfDetail');
                        };
                        editData.absence = arrayDataEdit('absence','levInfo','levList');
                        editData.movein = arrayDataEdit('movein','moveInInfo','moveInList');
                        editData.moveout = arrayDataEdit('moveout','moveOutInfo','moveOutList');
                    break;
                    case 'contractEmployeeInformation'://契約社員情報
                        editData.base = objectDataEdit('base','baseInfo','baseDetail','baseBfDetail');
                        editData.dpt = objectDataEdit('dpt','dptInfo','dptDetail','dptBfDetail'); 
                        editData.contract = objectDataEdit('contract','contInfo','contDetail','contBfDetail',true);
                        if(data.asgInfo !== undefined){
                            editData.assigned = objectDataEdit('assigned','asgInfo','asgDetail','asgBfDetail');
                        };
                        editData.absence = arrayDataEdit('absence','levInfo','levList');
                        editData.movein = arrayDataEdit('movein','moveInInfo','moveInList');
                        editData.moveout = arrayDataEdit('moveout','moveOutInfo','moveOutList');
                    break;
                    case 'secondedAcceptEmployeeInformation'://出向(受)社員情報
                        editData.base = objectDataEdit('base','baseInfo','baseDetail','baseBfDetail');
                        editData.dpt = objectDataEdit('dpt','dptInfo','dptDetail','dptBfDetail'); 
                        editData.accepted = objectDataEdit('accepted','acpInfo','acpDetail','acpBfDetail',true);
                        if(data.asgInfo !== undefined){
                            editData.assigned = objectDataEdit('assigned','asgInfo','asgDetail','asgBfDetail');
                        };
                        editData.absence = arrayDataEdit('absence','levInfo','levList');
                        editData.movein = arrayDataEdit('movein','moveInInfo','moveInList');
                        editData.moveout = arrayDataEdit('moveout','moveOutInfo','moveOutList');
                    break;
                    case 'secondedAssignedEmployeeInformation'://出向(出)社員情報
                        editData.base = objectDataEdit('base','baseInfo','baseDetail','baseBfDetail');
                        editData.dpt = objectDataEdit('dpt','dptInfo','dptDetail','dptBfDetail'); 
                        editData.assigned = objectDataEdit('assigned','asgInfo','asgDetail','asgBfDetail',true);
                        if(data.exptInfo !== undefined){
                            editData.expert = objectDataEdit('expert','exptInfo','exptDetail','exptBfDetail');
                        };
                        if(data.tmpInfo !== undefined){
                            editData.temporary = objectDataEdit('temporary','tmpInfo','tmpDetail','tmpBfDetail');
                        };
                        
                        if(data.contInfo !== undefined){
                            editData.contract = objectDataEdit('contract','contInfo','contDetail','contBfDetail');
                        };
                        if(data.acpInfo !== undefined){
                            editData.accepted = objectDataEdit('accepted','acpInfo','acpDetail','acpBfDetail');
                        };
                        editData.absence = arrayDataEdit('absence','levInfo','levList');
                        editData.movein = arrayDataEdit('movein','moveInInfo','moveInList');
                        editData.moveout = arrayDataEdit('moveout','moveOutInfo','moveOutList');
                       
                    break;
                    /* 休務休職〜転出の場合は、休務休職〜転出のみしか表示しない */
                    case 'leaveOfAbsenceInformation'://休務/休職情報
                        editData.absence = arrayChangeDataEdit('absence',arrayDataEdit('absence','levInfo','bfLevList'),arrayDataEdit('absence','levInfo','levList'),'absenceTermSrtDate');
                        editData.movein = arrayDataEdit('movein','moveInInfo','moveInList');
                        editData.moveout = arrayDataEdit('moveout','moveOutInfo','moveOutList');
                    break;
                    case 'moveInInformation'://転入情報
                        editData.movein = arrayChangeDataEdit('movein',arrayDataEdit('movein','moveInInfo','bfMoveInList'),arrayDataEdit('movein','moveInInfo','moveInList'),'moveInDate');
                        editData.absence = arrayDataEdit('absence','levInfo','levList');
                        editData.moveout = arrayDataEdit('moveout','moveOutInfo','moveOutList');
                    break;
                    case 'moveOutInformation'://転出情報
                        editData.moveout = arrayChangeDataEdit('moveout',arrayDataEdit('moveout','moveOutInfo','bfMoveOutList'),arrayDataEdit('moveout','moveOutInfo','moveOutList'),'moveOutDate');
                        editData.absence = arrayDataEdit('absence','levInfo','levList');
                        editData.movein = arrayDataEdit('movein','moveInInfo','moveInList');
                    break;
                    default:
                        editData = [];
                    break;
                };
                /* データセット */
                setValue("payload",editData);
                /* 表示用データ格納用stateにセット */
                setDisplayData(editData);
                setChangeFlags(changeFlagsObject);
            }else{//APIリクエスト結果 = 異常
                /* スナックバー表示 */
                setSnackbarMessage({      
                    ...snackbarMessage,
                    open:true,
                    message:result,//APIによるエラー
                    type: 1,//APIエラー時:1,それ以外:2 
                    level:'error',//エラースナックバー
                });
            }
        });
    };
    
    /* ====== 履歴を変更した時の処理 ====== */
    const onChangeHistory = (value) =>{
        getDetail(value)
    }

    /* ====== 戻るボタン押した時の処理 ====== */
    const onClickBack = () => {
        navigate('/employee/information/detail',{state:{empNmb:empNmb}});
    };

    /* ---------------------------------------------------- */
    /* ----------------------- data ----------------------- */
    /* ---------------------------------------------------- */
    /*====== テーブルの設定(基本情報、契約系) ======*/
    const checkTableConfig = (id) =>{
        let result;
        /* ======== テーブルの設定 ======== */
        /*------ ヘッダの設定 ------*/
        // id       : 項目名
        // rowSpan  : 2~ (縦に結合)
        // colSpan	: 2~ (横に結合)
        // align	: 整列(横方向) Center/inherit/justify/left/right
        // sortTable: true(ソート)
        // fixed	: 位置固定 true
        // left		: 左からの位置	0~
        // right	: 右からの位置 0~
        // width    : セルの幅
        // label1	: 表示名(1段目)
        // label2	: 表示名(2段目)
        // mark     : 入力必須を表す*を表示　true

        /* ====== テーブルヘッダーを定義 ====== */
        /* ====== 兼務部署テーブルヘッダー ====== */
        const headDataCncDptList =[
            { id: 'cncDptCd',align: 'left', width: '515px',  label1:'部署',},//部署
            { id: 'cncPostName', align: 'left', width: '120px', label1: '役職'},//役職
        ];
        /*====== BodyCellの設定 ======*/
        // name		    : 項目名
        // name2		: 項目名2 値を２つ受け取りたい場合
        // type         : cellの種類　button/checkBox/lable/numLable/labelRaito/labelMonth
        // align	    : 整列(横方向) Center/inherit/justify/left/right *全て（ただしinputの場合はinputの中の文字の位置を指定）
        // width        : selectの幅調整用
        // color        : 文字の色
        // backgroundColor: 背景の色
        // checkBox     : チェックボックスの名前  *input,checkBox
        // fontSize	    : 文字の大きさ デフォルトは12px *label,labelNum
        // color	    : フォントカラーまたはアイコンカラー(アイコンの場合はred/green/grayが選択可能) *label,labelNum,iconButton
        // func         : 処理 *button,iconButton,select
        // value		: btnFuncで受け取りたい値 *button,iconButton

        /* ====== 兼務部署テーブルデータ ====== */
        const bodyDataCncDptList = [
            { name: 'cncDptCd',type: 'label',  align: 'left'},
            { name: 'cncPostName', type:'label', align: 'left'},
        ];
        /* ====== LeftTitleテーブルの設定 ====== */
        //id:idを指定
        //label:左側に表示するタイトル*
        //list:右側に表示するコンテンツのリスト *
        //name:項目名
        //name2:項目名(type:categoryLabelを選択時のみ指定　minorCategory)
        //title:inputなどの隣に表示するタイトル
        //type:表示タイプ label/input/select/date/datetime/categoryLabel(問合せ情報問合せ種別用) *
        //rightLabel:inputなどの隣に表示するラベル 例：メールドメインなど
        //disable:変更不可にする true/false
        //readOnly:ラベル風にする　true/false（select/date/datetime)
        //width:幅の変更をする(inputのみ)
        /* ====== LeftTitleテーブルのデータ ====== */
        /* ====== 基本情報データ詳細 ====== */
        const employeeInformationTableConfig = [
            /*適用日 */
            {
                id:'row1', 
                label:'適用開始日', 
                list:[
                    {name:'aplySrtDate', type:'dateLabel'}
                ]
            },
            /*従業員番号 */
            {
                id:'row2', 
                label:'従業員番号', 
                list:[
                    {name:'empNmb',   type:'label'},
                ]
            },
            /*シメイ */
            {
                id:'row3', 
                label:'フリガナ', 
                list:[
                    {name:'empFrgnSrname', type:'label',title:'セイ：'},
                    {name:'empFrgnName', type:'label',title:'メイ：'},
                    {name:'empFrgnMidName', type:'label',title:'ミドルネーム：'},

                ]
            },
            /*氏名 */
            {
                id:'row4', 
                label:'氏名', 
                list:[
                    {name:'empJpnSrname', type:'label',title:'姓：'},
                    {name:'empJpnName', type:'label',title:'名：'},
                    {name:'empJpnMidName', type:'label',title:'ミドルネーム：'},
                ]
            },
            /*従業員名(ローマ) */
            {
                id:'row5', 
                label:'英名',
                list:[
                    {name:'empEngSrname', type:'label',title:'Surname：'},
                    {name:'empEngName', type:'label',title:'Given Name：'},
                    {name:'empEngMidName', type:'label',title:'Middle Name：'},
                ]
            },
            /*従業員名(略名) */
            {
                id:'row6', 
                label:'略名',
                list:[
                    {name:'empAbrName', type:'label'},
                ]
            },
            /*戸籍名 */
            {
                id:'row7', 
                label:'戸籍名', 
                list:[
                    {name:'empFmlyName', type:'label'}
                ]
            },
            /*性別 */
            {
                id:'row8', 
                label:'性別', 
                list:[
                    {name:'gendName', type:'label'},
                ]
            },
            /*生年月日 */
            {
                id:'row9', 
                label:'生年月日', 
                list:[
                    {name:'bday', type:'dateLabel'},
                    ]
            },
            /*雇用形態 */
            {
                id:'row13', 
                label:'雇用形態', 
                list:[
                    {name:'empiSttsName', type:'label'},
                ]
            },
            /*入社日(開始日) */
            {
                id:'row14', 
                label:'入社日(開始日)', 
                list:[
                    {name:'entryDate', type:'dateLabel'},
                ]
            },
            /*誓約書提出日 */
            {
                id:'row15', 
                label:'誓約書提出日', 
                list:[
                    {name:'plgePresnDate', type:'dateLabel'},
                ]
            },
            
            /*勤務地 */
            {
                id:'row16', 
                label:'勤務地', 
                list:[
                    {name:'workLocoName', type:'label'},
                ]
            },
            /*勤務地住所 */
            {id:'row17', 
            label:'勤務地住所', 
            list:[
                    {name:'workLocoAdres',type:'label'},
                ]
            },
            /*ランク */
            {id:'row18', 
            label:'ランク', 
            list:[
                    {name:'rkName', type:'label'},
                ]
            },
            /*人事No */
            {
                id:'row20', 
                label:'人事稟議番号', 
                list:[
                    {name:'hrAprvNmb', type:'label'},
                ]
            },
            /*稟議起案時費用 */
            {
                id:'row21', 
                label:'稟議起案時費用', 
                list:[
                    {name:'aprvOrgTimeCst', type:'moneyLabel'},
                ]
            },
            /*最終出社日 */
            {
                id:'row22', 
                label:'最終出社日', 
                list:[
                    {name:'lastToWorkDate', type:'dateLabel'},
                ]
            },
            /*退職日(終了日) */
            {
                id:'row23', 
                label:'退職日(終了日)', 
                list:[
                    {name:'rtiDate', type:'dateLabel'},
                ]
            },
            /*コメント */
            {
                id:'row24', 
                label:'コメント欄', 
                list:[
                    {name:'cmntField', type:'label'},
                ]
            },

        ];
    //    /* ====== 所属部署情報データ詳細 ====== */
       const affiliatedDepartmentInformationTableConfig = [ 
        /*適用日 */
        {
            id:'row1', 
            label:'適用開始日', 
            list:[
                {name:'afiDptAplySrtDate', type:'dateLabel'}
            ]
        },
        /*部署 */
        {
            id:'row10', 
            label:'部署', 
            list:[
                {name:'dptCd', name2:'dptName', type:'label'},
            ]
        },
        /*人件費区分 */
        {
            id:'row19', 
            label:'人件費区分', 
            list:[
                {name:'lboCstClasfName',type:'label'},
            ]
        },
        /*役職 */
        {
            id:'row11', 
            label:'役職', 
            list:[
                {name:'postName',type:'label'},
            ]
        },
        /*兼務部署 */
        {
            id:'row12', 
            label:'兼務部署', 
            list:[
                {
                    name:'cncDptList', 
                    type: 'table',
                    tableHeader:headDataCncDptList,
                    tableBody:bodyDataCncDptList,
                },
            ]
        },
    ];

        
        /* ====== エキスパート社員データ ====== */
        const expertInformationTableConfig = 
            [     
                /* 適用開始日 */   
                {
                    id:'row1', 
                    label:'適用開始日', 
                    list:[
                        {name:'exptAplySrtDate', type:'dateLabel'}
                    ]
                },
                /* 等級 */
                {
                    id:'row2', 
                    label:'等級',  
                    list:[
                        {name:'gradeName', type:'label'},
                    ]
                },
                /* 管理監督者フラグ */
                {
                    id:'row3', 
                    label:'管理監督者', 
                    list:[
                        {name:'mnaSpvrFlag',type:'checkboxLabel', disabled: true},
                    ],
                },
            ];
        /* ====== 派遣社員データ ====== */
        const tmpInformationTableConfig =
            [     /*適用開始日 */
                /*派遣元会社 */
                {
                    id:'row1', 
                    label:'派遣元会社名', 
                    list:[
                        {name:'tmpAgnCmpCd', type:'label'},
                    ]
                },
                /*雇用期間の定め */
                {
                    id:'row2', 
                    label:'雇用期間の定め', 
                    list:[
                        {name:'empiTermDciFlag',   type:'edit',master:employmentTermDisitionFlag},
                    ]
                },
                /*紹介予定派遣 */
                {
                    id:'row3', 
                    label:'紹介予定派遣', 
                    list:[
                        {name:'itrSchedTmpFlag', type:'edit',master:introductionScheduleTemporaryFlag},
                    ]
                },
                {
                    id:'row4', 
                    label:'契約開始日', 
                    list:[
                        {name:'tmpCntrTermSrtDate', type:'dateLabel'}
                    ]
                },
                /*契約満了予定日 */
                {
                    id:'row5',
                    label:'契約満了予定日', 
                    list:[
                        {name:'tmpBfCntrTermEndDate',   type:'dateLabel'},
                    ]
                },
                /*個人抵触日 */
                {
                    id:'row6', 
                    label:'個人抵触日', 
                    list:[
                        {name:'idiCntDate',   type:'dateLabel'},
                    ]
                },
                /*派遣先責任者 */
                {
                    id:'row7', 
                    label:'派遣先責任者', 
                    list:[
                        {name:'tmpFirstRspPsnEmpNmb', type:'label'},
                    ]
                },
                /*指揮命令者 */
                {
                    id:'row8', 
                    label:'指揮命令者', 
                    list:[
                        {name:'ledrEmpNmb', type:'label'},
                    ]
                },
                /*時間単価 */
                {
                    id:'row9', 
                    label:'時間単価', 
                    list:[
                        {name:'hurRate', type:'label'},
                    ]
                },
                /*初回時間単価 */
                {
                    id:'row9', 
                    label:'初回時間単価', 
                    list:[
                        {name:'frsFirstHurRate', type:'label'},
                    ]
                },
                /*時間単価備考 */
                {
                    id:'row10', 
                    label:'時間単価備考', 
                    list:[
                        {name:'uitCstRema',   type:'label'},
                    ]
                },
                /*フレックス適用 */
                {
                    id:'row11', 
                    label:'フレックス適用', 
                    list:[
                        {name:'flexAplyFlag',type:'edit',master:flexApplyFlag},
                    ]
                },
                /*業務内容 */
                {
                    id:'row12', 
                    label:'業務内容', 
                    list:[
                        {name:'tmpBsiContField',   type:'label'},
                    ]
                },
                /*業務内容詳細 */
                {
                    id:'row13', 
                    label:'業務内容詳細', 
                    list:[
                        {name:'tmpBsiContDta',   type:'label'},
                    ]
                },
                /*備考 */
                {
                    id:'row14', 
                    label:'出向社員情報 備考', 
                    list:[
                        {name:'tmpInfoRema',   type:'label'},
                    ]
                },
                /*契約対象外 */
                {
                    id:'row15', 
                    label:'契約書対象外', 
                    list:[
                        {name:'cntrNtTgtFlag',type:'checkboxLabel',disabled: true},
                    ]
                },
                /*WEB勤怠対象外 */
                {
                    id:'row16', 
                    label:'WEB勤怠対象外', 
                    list:[
                        {name:'webAttdNtTgtFlag',type:'checkboxLabel',disabled: true},
                    ]
                },
            ]
        // const changeRequired  = (value) =>{
        // 	const tableConfigCopy = [...temporaryUpdateInformationTableConfig];
        // 	const index = tableConfigCopy.findIndex((obj) => obj.id === 'idiCntDate');
        // 	const requiredFlag = (value === 'true');
        // 	tableConfigCopy[index].required = requiredFlag;
        // 	tableConfigCopy[index].list[0].required = requiredFlag;
        // 	setTemporaryTableData(tableConfigCopy);
        // }

        

        /* ====== 出向社員(出)社員データ ====== */
        const assignedInformationTableConfig = 
            [   
                /*出向開始日 */
                {
                    id:'row1', 
                    label:'出向開始日', 
                    list:[
                        {name:'secSrtDate',type:'dateLabel'}
                    ]
                },
                /*帰任日*/
                {
                    id:'row2', 
                    label:'帰任日', 
                    list:[
                        {name:'rtnDate',   type:'dateLabel'},
                    ]
                },
                /*出向先会社名 */
                {
                    id:'row3', 
                    label:'出向先会社名', 
                    list:[
                        {name:'secDestnCmpCd', type:'label'},
                        
                    ]
                },
                /*出向先部署名*/
                {
                    id:'row4', 
                    label:'出向先部署名', 
                    list:[
                        {name:'secDestnDpt',   type:'label'},
                    ]
                },
                /*費用負担(TC:出向先) */
                {
                    id:'row5', 
                    label:'費用負担(TC:出向先)', 
                    list:[
                        {name:'cstBrd',   type:'label'},
                    ]
                },
                /*出向前所属部署 */
                {
                    id:'row6', 
                    label:'出向前所属部署', 
                    list:[
                        {name:'bfSecAfiDptCd',   type:'label'},
                    ]
                },
                /*備考 */
                {
                    id:'row7', 
                    label:'備考', 
                    list:[
                        {name:'secAsiInfoRema', type:'label'},
                    ]
                },
                /*出向期間開始日 */
                {
                    id:'row8', 
                    label:'出向期間開始日', 
                    list:[
                        {name:'crntSecTermSrtDate', type:'dateLabel'}
                    ]
                },
                /*出向期間終了日 */
                {
                    id:'row9', 
                    label:'出向期間終了日', 
                    list:[
                        {name:'crntSecTermEndDate', type:'dateLabel'}
                    ]
                },
            ];
        /* ====== 出向社員(受)社員データ ====== */
        const acceptedInformationTableConfig = 
        [     
            /*出向元会社 */
            {
                id:'row1', 
                label:'出向元会社名', 
                list:[
                    {name:'secFrmCmpCd', type:'label'},
                ]
            },
            /*給与基準*/
            {
                id:'row2', 
                label:'給与基準', 
                list:[
                    {name:'slaBaseName',type:'label'},
                ]
            },
            /*旅費基準 */
            {
                id:'row3', 
                label:'旅費基準', 
                list:[
                    {name:'bsiTripExpeStndName',type:'label'},
                ]
            },
            /*契約書フォーマット*/
            {
                id:'row4', 
                label:'契約書フォーマット', 
                list:[
                    {name:'cntrFrmtName',type:'label'},
                ]
            },
            /*初回契約開始日 */
            {
                id:'row5', 
                label:'初回契約開始日', 
                list:[
                    {name:'secAcpFirstCntrSrtDate',   type:'dateLabel'},
                ]
            },
            /*適用開始日 */
            {
                id:'row6', 
                label:'現契約開始日', 
                list:[
                    {name:'secAcpCntrTermSrtDate', type:'dateLabel'}
                ]
            },
            /*現契約満了予定日 */
            {
                id:'row7', 
                label:'現契約満了予定日', 
                list:[
                    {name:'secAcpCntrTermExpiDate',   type:'dateLabel'},
                ]
            },
            /*出向社員情報 備考 */
            {
                id:'row8', 
                label:'出向社員情報 備考', 
                list:[
                    {name:'secAcpInfoRema', type:'label'},
                ]
            },
            /*管理監督者 */
            {
                id:'row9', 
                label:'管理監督者', 
                list:[
                {name:'mnaSpvrFlag',type:'checkboxLabel',disabled: true},
                ]
            },
        
        ]

        
        /* ====== 契約社員データ ====== */
        const contractInformationTableConfig = 
        [    
            /*給与形態 */
            {
                id:'row1', 
                label:'給与形態', 
                list:[
                    {name:'slaFormName', type:'label'}
                ]
            },
            /*職種 */
            {
                id:'row2', 
                label:'職種', 
                list:[
                    {name:'ocuName',type:'label'},
                ]
            },
            /*特記事項 */
            {
                id:'row12', 
                label:'配布方法', 
                list:[
                    {name:'distMerh',   type:'label'},
                ]
            },
            /*担当業務内容 */
            {
                id:'row13', 
                label:'担当業務内容', 
                list:[
                    {name:'cntrBsiContField',   type:'label'},
                ]
            },
            /*差し込み印刷対応 */
            {
                id:'row14', 
                label:'差し込み印刷対応', 
                list:[
                    {name:'mergePrintSprt',   type:'label'},
                ]
            },
            /*契約開始日 */
            {
                id:'row15', 
                label:'契約開始日', 
                list:[
                    {name:'cntrSrtDate',
                    type:'dateLabel',
                },
                ]
            },
            /*最長雇用期間 */
            {
                id:'row16',
                label:'最長雇用期間',
                list:[
                    {name:'lngEmpiTerm',   type:'dateLabel'},
                ]
            },
            /*更新間隔 */
            {
                id:'row17', 
                label:'更新間隔', 
                list:[
                    {name:'upIte',   type:'label'},
                ]
            },
            /* 契約期間開始日 */
            {
                id:'row18', 
                label:'契約期間開始日', 
                list:[
                    {name:'cntrTermSrtDate', type:'dateLabel'}
                ]
            },
            /*契約期間満了予定日 */
            {
                id:'row19', 
                label:'契約期間満了予定日', 
                list:[
                    {name:'cntrTermExpiDate',   type:'dateLabel'},
                ]
            },
            /*契約社員情報備考 */
            {
                id:'row20', 
                label:'契約社員情報備考',  
                list:[
                    {name:'cntrInfoRema',   type:'label'},
                ]
            },
            /* 等級 */
            {
                id:'row21', 
                label:'等級',  
                list:[
                    {name:'gradeName',type:'label'},
                ]
            },
            /* 管理監督者フラグ */
            {
                id:'row22', 
                label:'管理監督者', 
                list:[
                    {name:'mnaSpvrFlag',type:'checkboxLabel', disabled: true},
                ],
            },
        ]
        switch(id){
            case'base':
            result = employeeInformationTableConfig;
            break;
            case'dpt':
            result = affiliatedDepartmentInformationTableConfig;
            break;            
            case'expert':
            result = expertInformationTableConfig;
            break;
            case'temporary':
            result = tmpInformationTableConfig;
            break;
            case'assigned':
            result = assignedInformationTableConfig;
            break;
            case'accepted':
            result = acceptedInformationTableConfig;
            break;
            case'contract':
            result = contractInformationTableConfig;
            break;
            default:
                result = employeeInformationTableConfig;
            break;
        };
        return result;
    };

    /*====== テーブルの設定(休務休職、転入、転出)ヘッダー ======*/
    const checkTableArrayHeaderConfig = (id) =>{
        let result;
        /* ======== テーブルの設定 ======== */
        /*------ ヘッダの設定 ------*/
        // id       : 項目名
        // rowSpan  : 2~ (縦に結合)
        // colSpan	: 2~ (横に結合)
        // align	: 整列(横方向) Center/inherit/justify/left/right
        // sortTable: true(ソート)
        // fixed	: 位置固定 true
        // left		: 左からの位置	0~
        // right	: 右からの位置 0~
        // width    : セルの幅
        // label1	: 表示名(1段目)
        // label2	: 表示名(2段目)
        // mark     : 入力必須を表す*を表示　true

        /* ====== 転入情報詳細テーブルヘッダー ====== */
        /* ====== 休務/休暇情報詳細テーブルヘッダー ====== */
        const headDataAbsence =[
            { id: 'absenceTermSrtDate', align: 'left', width: '150px', label1: '休務/休職開始日'},//開始日
            { id: 'absenceTermEndDate', align: 'left', width: '150px',  label1: '休務/休職終了日'},//データ入力日
            { id: 'loaClasfName', align: 'left', width: '150px',  label1:'区分'},//区分
            { id: 'lastUdr',align: 'left', width: '120px',  label1: '最終更新者'},//最終更新者
            { id: 'lastUpDate', align: 'left', width: '120px',label1: '最終更新日'},//最終更新日
        ];
        const headDataMoveIn =[
            { id: 'moveInDate', align: 'left', width: '150px',  label1:'転入日',},//転入日
            { id: 'moveInRemaField', align: 'left', width: '300px', label1: '備考'},//備考
            { id: 'lastUdr',align: 'left', width: '120px',  label1: '最終更新者'},//最終更新者
            { id: 'lastUpDate', align: 'left', width: '120px',label1: '最終更新日'},//最終更新日
        ];
        /* ====== 転出情報詳細テーブルヘッダー ====== */
        const headDataMoveOut =[
            { id: 'moveOutDate', align: 'left', width: '150px',  label1:'転出日'},//転出日
            { id: 'moveInRemaField', align: 'left', width: '300px',  label1: '備考'},//備考
            { id: 'lastUdr',align: 'left', width: '120px',  label1: '最終更新者'},//最終更新者
            { id: 'lastUpDate', align: 'left', width: '120px',label1: '最終更新日'},//最終更新日
        ];

        switch(id){
            case'absence':
                result = headDataAbsence;
                break;
            case'movein':
                result = headDataMoveIn;
                break;
            case'moveout':
                result = headDataMoveOut;
                break;
            default:
                result = headDataMoveIn;
                break;
        };
        return result;
    };
    /*====== テーブルの設定(休務休職、転入、転出)ボディ ======*/
    const checkTableArrayBodyConfig = (id) =>{
        let result;
        /*====== BodyCellの設定 ======*/
        // name		    : 項目名
        // name2		: 項目名2 値を２つ受け取りたい場合
        // type         : cellの種類　button/checkBox/lable/numLable/labelRaito/labelMonth
        // align	    : 整列(横方向) Center/inherit/justify/left/right *全て（ただしinputの場合はinputの中の文字の位置を指定）
        // width        : selectの幅調整用
        // color        : 文字の色
        // backgroundColor: 背景の色
        // checkBox     : チェックボックスの名前  *input,checkBox
        // fontSize	    : 文字の大きさ デフォルトは12px *label,labelNum
        // color	    : フォントカラーまたはアイコンカラー(アイコンの場合はred/green/grayが選択可能) *label,labelNum,iconButton
        // func         : 処理 *button,iconButton,select
        // value		: btnFuncで受け取りたい値 *button,iconButton

        /* ====== 休務/休暇情報テーブルデータ ====== */
        /* ====== 転出情報テーブルデータ ====== */
        const bodyDataMoveOut = [
            { name: 'moveOutDate', type: 'dateLabel',  align: 'left'},
            { name: 'moveOutRemaField', type: 'label', align: 'left'},
            { name: 'lastUdr',  type: 'label', align: 'left'},
            { name: 'lastUpDate', type: 'timeLabel', align: 'left'},
        ];
        const bodyDataAbsence = [
            { name: 'absenceTermSrtDate', type: 'dateLabel', align: 'left'},
            { name: 'absenceTermEndDate', type: 'dateLabel', align: 'left'},
            { name: 'loaClasfName', type:'label',align: 'left'},
            { name: 'lastUdr',type: 'label', align: 'left'},
            { name: 'lastUpDate',type: 'timeLabel', align: 'left'},
        ];
        /* ====== 転入情報テーブルデータ ====== */
        const bodyDataMovein = [
            { name: 'moveInDate', type: 'dateLabel',  align: 'left'},
            { name: 'moveInRemaField', type: 'label', align: 'left'},
            { name: 'lastUdr',type: 'label', align: 'left'},
            { name: 'lastUpDate',type: 'timeLabel', align: 'left'},
        ];

        switch(id){
            case'absence':
                result = bodyDataAbsence;
                break;
            case'movein':
                result = bodyDataMovein;
                break;
            case'moveout':
                result = bodyDataMoveOut;
                break;
            default:
                result = bodyDataMovein;
                break;
        };

        return result;
    };

    /*====== アンカーコンテンツ ======*/
    const anchorContents = [
        // {id:'applyDate',name:'適用開始日',  status:'applyDate'},
        {id:'base',name:'基本情報',  status:'base'},
        {id:'dpt',name:'所属部署情報',  status:'dpt'},        
        {id:'absence',name:'休務/休暇情報',  status:'absence'},
        {id:'movein',name:'転入情報',  status:'movein'},
        {id:'moveout',name:'転出情報',  status:'moveout'},

        // {id:'retirement',name:'退職情報',  status:'retirement'},
        // {id:'dispatch',name:'派遣社員',  status:'dispatch'},
        // {id:'temporary',name:'契約社員',  status:'temporary'},
        // {id:'assigned',name:'出向(受)社員',  status:'assigned'},
        // {id:'contract',name:'出向(出)社員',  status:'contract'},
    ];

    /*====== fieldArrayの設定 ======*/
    const fieldList = [
        {id:'absence',blockTitle:'休務/休職情報'},
        {id:'movein',blockTitle:'転入情報'},
        {id:'moveout',blockTitle:'転出情報'}
    ];

    /* ---------------------------------------------------- */
    /* ----------------------- jsx ------------------------ */
    /* ---------------------------------------------------- */
    /* ====== 画面表示開始前 ====== */
    if(!loading){
        return(
        <></>
        );
    };

    /* ---------------------------------------------------- */
    /* -------------------- Start Render ------------------ */
    /* ---------------------------------------------------- */ 
    return(
        <>
            <LoadingProgressBar open={progress}/>
            <EmployeeStyle.SdivWrapper>
                {/* 画面タイトル */}
                <Title text={'従業員情報更新履歴'} contents={anchorContents}/>
                {/* ページコンテンツ */}
                <CommonStyle.GdivPageContentsWrapper >
                    <CommonStyle.GdivSubTitleWrapper id='base'>
                        <EmployeeStyle.SdivTitleButton className='titleText' style={{fontSize:assets().size.titleText}}>履歴</EmployeeStyle.SdivTitleButton>
                    </CommonStyle.GdivSubTitleWrapper>
                    {/* 履歴テーブル */}
                    {historyData.length > 0 && 
                    <HistryTable data={historyData} onChangeHistory={onChangeHistory}/>
                    }                    
                </CommonStyle.GdivPageContentsWrapper>
                <div style={{display:'flex',marginTop:'5px'}}>
                    <div>
                        {displayData?.base &&
                        <CommonStyle.GdivPageContentsWrapper >
                            <EmployeeStyle.SInformationBlock
                                    id='base'
                                    type='detail'
                                    blockTitle='基本情報'>
                                    <LeftTitleTable
                                        register={register}
                                        payload='payload'
                                        error={errors}
                                        dataRow={displayData.base}
                                        tableConfig={checkTableConfig('base')}
                                        changeFlags={changeFlags}
                                        />
                            </EmployeeStyle.SInformationBlock>
                        </CommonStyle.GdivPageContentsWrapper>}
                        {fieldList.map((item)=>(
                            displayData?.[item.id] && (
                                <CommonStyle.GdivPageContentsWrapper>
                                </CommonStyle.GdivPageContentsWrapper>
                            )
                        ))}
                        {fieldList.map((item)=>(
                            displayData?.[`${item.id}New`] && (
                                <CommonStyle.GdivPageContentsWrapper>
                                    <div style={{fontSize:'30px',fontWeight:'bold'}}>↓</div>
                                    <EmployeeStyle.SInformationTable
                                        id={item.id}
                                        blockTitle={item.blockTitle}
                                        >
                                    </EmployeeStyle.SInformationTable>
                                </CommonStyle.GdivPageContentsWrapper>
                            )
                        ))}

                        {displayData?.dpt &&
                        <CommonStyle.GdivPageContentsWrapper >
                            <EmployeeStyle.SInformationBlock
                                    id='dpt'
                                    type='detail'
                                    blockTitle='所属部署情報'>
                                    <LeftTitleTable
                                        register={register}
                                        payload='payload'
                                        error={errors}
                                        dataRow={displayData.dpt}
                                        tableConfig={checkTableConfig('dpt')}
                                        changeFlags={changeFlags}
                                        />
                            </EmployeeStyle.SInformationBlock>
                        </CommonStyle.GdivPageContentsWrapper>}
                        {fieldList.map((item)=>(
                            displayData?.[item.id] && (
                                <CommonStyle.GdivPageContentsWrapper>
                                    <EmployeeStyle.SInformationTable
                                        id={item.id}
                                        blockTitle={item.blockTitle}
                                        >
                                        <Table
                                            headCells={checkTableArrayHeaderConfig(item.id)} //ヘッダの設定情報
                                            bodyCells={checkTableArrayBodyConfig(item.id)} //ボディの設定情報
                                            dataRow={displayData[item.id]} //表示データ
                                            changeFlags={changeFlags[item.id]}
                                            // paperStyle={{maxHeight:'calc(20vh)'}} //高さはここ
                                            register={register}
                                            payload='payload'
                                            showBottom={true}
                                            editMode={false}
                                            notShowSearchNumber={true}
                                            payloadCategory={item.id}
                                        />    
                                    </EmployeeStyle.SInformationTable>
                                </CommonStyle.GdivPageContentsWrapper>
                            )
                        ))}
                        {/* {fieldList.map((item)=>(
                            displayData?.[`${item.id}New`] && (
                                <CommonStyle.GdivPageContentsWrapper>
                                    <div style={{fontSize:'30px',fontWeight:'bold'}}>↓</div>
                                    <EmployeeStyle.SInformationTable
                                        id={item.id}
                                        blockTitle={item.blockTitle}
                                        >
                                    </EmployeeStyle.SInformationTable>
                                </CommonStyle.GdivPageContentsWrapper>
                            )
                        ))} */}
                    </div>                                       
                    <div>
                        
                        <CommonStyle.GdivPageContentsWrapper>
                            {/* エキスパート情報 */}
                            {displayData?.expert &&
                                <EmployeeStyle.SInformationBlock
                                    id='expert'
                                    type='detail'
                                    blockTitle='エキスパート情報'>
                                    <LeftTitleTable
                                        register={register}
                                        payload='payload'
                                        dataRow={displayData.expert}
                                        tableConfig={checkTableConfig('expert')}
                                        changeFlags={changeFlags}
                                        minWidthR={'430px'}
                                        />
                                </EmployeeStyle.SInformationBlock>}
                            {/* 派遣社員員情報 */}
                            {displayData?.temporary &&
                                <EmployeeStyle.SInformationBlock
                                    id='temporary'
                                    type='detail'
                                    blockTitle='派遣社員情報'>
                                    <LeftTitleTable
                                        register={register}
                                        payload='payload'
                                        dataRow={displayData.temporary}
                                        tableConfig={checkTableConfig('temporary')}
                                        changeFlags={changeFlags}
                                        minWidthR={'430px'}
                                        />
                                    </EmployeeStyle.SInformationBlock>}
                            {/* 出向(出)情報 */}
                            {displayData?.assigned &&
                                <EmployeeStyle.SInformationBlock
                                    id='assigned'
                                    type='detail'
                                    blockTitle='出向(出)情報'>
                                        <LeftTitleTable
                                            register={register}
                                            payload='payload'
                                            dataRow={displayData.assigned}
                                            tableConfig={checkTableConfig('assigned')}
                                            changeFlags={changeFlags}
                                            minWidthR={'430px'}
                                            />
                                </EmployeeStyle.SInformationBlock>}
                            {/* 出向(受)情報 */}
                            { displayData?.accepted &&
                                <EmployeeStyle.SInformationBlock
                                id='accepted'
                                type='detail'
                                blockTitle='出向(受)情報'>
                                    <LeftTitleTable
                                        register={register}
                                        payload='payload'
                                        dataRow={displayData.accepted}
                                        tableConfig={checkTableConfig('accepted')}
                                        changeFlags={changeFlags}
                                        minWidthR={'430px'}
                                        />
                                </EmployeeStyle.SInformationBlock>}
                            {/* 契約社員情報 */}
                            { displayData?.contract &&
                                <EmployeeStyle.SInformationBlock
                                    id='contract'
                                    type='detail'
                                    blockTitle='契約社員情報'>
                                        <LeftTitleTable
                                            register={register}
                                            payload='payload'
                                            error={errors}
                                            dataRow={displayData.contract}
                                            tableConfig={checkTableConfig('contract')}
                                            changeFlags={changeFlags}
                                            minWidthR={'430px'}
                                            />
                                </EmployeeStyle.SInformationBlock>}
                        </CommonStyle.GdivPageContentsWrapper>
                    </div>
                </div>
                {/* アンダーバー */}
                <Underbar
                onClickLeft={onClickBack}
                type={'back'}
                />
            </EmployeeStyle.SdivWrapper>
            {/* スナックバー */}
            <SnackBar
                content={snackbarMessage}
                set={setSnackbarMessage}/>
        </>
    )
};

/* ======================================================================================================================================================= */  
/* ==================================================================== End Of Program =================================================================== */  
/* ======================================================================================================================================================= */